import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";

const CTASection = () => {
  return (
    <section id="cta" className="py-16 md:py-24 relative overflow-hidden" aria-labelledby="cta-heading">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-gradient-to-r from-electric-purple/10 via-transparent to-cyber-cyan/10" aria-hidden="true" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] md:w-[600px] h-[400px] md:h-[600px] bg-gradient-to-r from-electric-purple/20 to-cyber-cyan/20 rounded-full blur-[100px] md:blur-[150px]" aria-hidden="true" />

      <div className="container mx-auto px-4 relative z-10">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="glass-card rounded-2xl md:rounded-3xl p-6 md:p-12 lg:p-16 text-center max-w-4xl mx-auto neon-border-purple"
        >
          <h2 id="cta-heading" className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-display font-bold mb-4 md:mb-6">
            Pronto para transformar{" "}
            <span className="text-gradient-zavvi">seu atendimento?</span>
          </h2>
          <p className="text-base md:text-lg text-body-text mb-6 md:mb-8 max-w-2xl mx-auto">
            Junte-se a +500 empresas que já centralizaram sua gestão de clientes.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
            <Button 
              variant="hero" 
              size="lg" 
              className="w-full sm:w-auto min-h-[48px]"
              onClick={() => document.getElementById('planos')?.scrollIntoView({ behavior: 'smooth' })}
              aria-label="Ver planos disponíveis e preços"
            >
              Ver Planos
              <ArrowRight size={18} aria-hidden="true" />
            </Button>
            <Button 
              variant="outline-purple" 
              size="lg" 
              className="w-full sm:w-auto min-h-[48px]"
              onClick={() => window.open('https://zavviapp.zavvi.ai/signup', '_blank')}
              aria-label="Iniciar teste grátis de 14 dias na plataforma Zavvi"
            >
              Fazer teste grátis de 14 dias
            </Button>
          </div>

          {/* Social Proof */}
          <div className="mt-8 md:mt-12 pt-6 md:pt-8 border-t border-border">
            <p className="text-muted-foreground text-xs md:text-sm mb-4 md:mb-6">
              Empresas que confiam na Zavvi.ai
            </p>
            <div className="flex flex-wrap justify-center gap-4 md:gap-8">
              {[
                { name: "NovaTech", initials: "NT" },
                { name: "Vertice", initials: "GV" },
                { name: "Conexa", initials: "CD" },
                { name: "Prime", initials: "PA" },
                { name: "Velox", initials: "VL" },
              ].map((company) => (
                <div key={company.name} className="flex items-center gap-2 opacity-60 hover:opacity-100 transition-opacity">
                  <div className="w-7 md:w-8 h-7 md:h-8 rounded-lg bg-muted flex items-center justify-center">
                    <span className="text-foreground font-bold text-[10px] md:text-xs">{company.initials}</span>
                  </div>
                  <span className="text-foreground font-display font-semibold text-xs md:text-sm hidden sm:block">
                    {company.name}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
